import { uploadLineAudio } from "../../actions"
import { bufferToWave } from "../AudioRecorder/buffer-to-wave"
import { DialogueLine } from "../Session/Dialogue"

export function saveAudio(line: DialogueLine) {
    if (!line.recordedAudio) return Promise.reject('Must provide recordedAudio AudioBuffer.')
    const waveBlob = bufferToWave(line.recordedAudio, line.recordedAudio.length)
    return uploadLineAudio(line.line.id, waveBlob)
}